'use client';

import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useReducer,
  useState,
} from 'react';
import { API } from 'aws-amplify';
import { OnViewerNumberChangeDocument } from '@/src/v2/service/v2/graphql/generated/gql-api.generated';

type IClientContext = {
  counters: any;
  streamCounters: any;
  reload: boolean;
  attempts: number;
  updateAttempts: (attempt: number) => void;
  updateReload: () => void;
  reloadEvent: boolean;
  updateEventReload: () => void;
};

export const ClientContext = createContext({} as IClientContext);

export const useClientContext = () => useContext(ClientContext);

const reducer = (state, action) => {
  switch (action.type) {
    case 'add': {
      return {
        ...state,
        [action.payload.id]: action.payload.view,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

const streamReducer = (state, action) => {
  switch (action.type) {
    case 'add': {
      return {
        ...state,
        [action.payload.id]: action.payload.view,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export const ClientContextProvider: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [reload, setReload] = useState(false);
  const [reloadEvent, setReloadEvent] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const MAX_LOGIN_ATTEMPT = 5;

  const updateReload = () => {
    setReload(!reload);
  };
  const updateAttempts = (attemp: number) => {
    setAttempts(attemp);
  };
  const updateEventReload = () => {
    setReloadEvent(!reloadEvent);
  };
  const [counters, counterDispatch] = useReducer(reducer, {});
  const [streamCounters, counterStreamDispatch] = useReducer(streamReducer, {});

  useEffect(() => {
    const observable = API.graphql({
      query: OnViewerNumberChangeDocument,
    }) as any;
    let obs = observable.subscribe({
      next: (data: any) => {
        const payload = data.value.data.onViewerNumberChange;
        if (payload.type === 'event') {
          counterDispatch({
            type: 'add',
            payload: {
              id: payload.id,
              view: {
                total: payload.total,
                current: payload.current,
              },
            },
          });
        }
      },
      error: (error) => {
        // console.error(error);
      },
    });
    return () => {
      obs.unsubscribe();
    };
  });

  useEffect(() => {
    const observable = API.graphql({
      query: OnViewerNumberChangeDocument,
    }) as any;
    let obs = observable.subscribe({
      next: (data: any) => {
        const payload = data.value.data.onViewerNumberChange;
        if (payload.type === 'stream') {
          counterStreamDispatch({
            type: 'add',
            payload: {
              id: payload.id,
              view: {
                total: payload.total,
                current: payload.current,
              },
            },
          });
        }
      },
      error: (error) => {
        // console.error(error);
      },
    });
    return () => {
      obs.unsubscribe();
    };
  });

  return (
    <ClientContext.Provider
      value={{
        counters,
        streamCounters,
        reload,
        updateReload,
        reloadEvent,
        updateEventReload,
        attempts,
        updateAttempts,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};
